<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Smart Route Assigner</span><br/>

      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-right: 10px">
        this page provides suggested driver assignments and allows you to push assignments to TBN.
        <span style="float:right;"><b-button variant="success" size="sm" @click="view_more_info = !view_more_info"><b>more info</b></b-button></span>
      </div>

    </div>

    <b-modal title="Smart Route Assigner Info" size="xl" v-model="view_more_info" ok-only>
      <br/>
      This page shows bookings that start on the given calendar date.  It uses the attributes of bookings and drivers to find compatible and rank drivers by customizable criteria
      <br/><br/>
      <b>Driver Attributes</b>
      <br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;These are used to determine compatability with bookings and to rank the best fit.
      <br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;Drivers with other bookings that start or end within 10 hours of a booking are also excluded
      <br/><br/>
      <b>Ranking Logic</b>
      <br/><br/>
      drivers that are compatible with a booking are ranked by the following attributes in order:
      <br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;driver type: full-time, part-time, casual
      <br/>
      &nbsp;&nbsp;&nbsp;&nbsp;seniority: highest to lowest
      <br/>
      &nbsp;&nbsp;&nbsp;&nbsp;Samsara Safety Score Rank (last 30 days): lowest to highest
      <br/><br/>
      <b>Suggested Assignment Results</b>
      <br/><br/>
      The results list are ordered / grouped as follows:
      <br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;BEST MATCHES - the top 5 matches are list with details
      <br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;ALL COMPATIBLE - all remaining compatible drivers are listed in rank order
      <br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;ALL INCOMPATIBLE - all incompatible drivers are then listed
      <br/><br/>
    </b-modal>

    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data(false)" :disabled="loading">Show Assignments</b-button>
      &nbsp;&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data(true)" :disabled="loading">Auto Generate</b-button>
    </div>
    <div style="position: relative; font-size: 18px; margin: 30px 100px 20px 100px" class="align-right d-flex align-items-center justify-content-center">
      <b>Vehicle Types:</b> &nbsp;&nbsp; <b-form-checkbox-group v-model="selected_vehicle_types" :options="vehicle_type_options"></b-form-checkbox-group>
    </div>
    <div v-if="summary.total_cnt" style="font-weight: bold; font-size: 22px; margin: 20px">
      <div style="float: left" class="align-right d-flex align-items-center justify-content-center">
        <div v-if="summary.total_cnt" style="border: 1px solid grey; padding-right: 15px; padding-left: 15px; margin-right:30px">Results: {{items.length}} of {{summary.total_cnt}}</div>
        Filter: &nbsp;<b-form-input style="width: 200px" v-model="booking_filter" placeholder="charterID,vehicle,driver"/>
      </div>
      <div style="float: right">
        <b-button v-on:click.prevent="save_all_recommended_drivers()" :disabled="updating">Save All</b-button>
        &nbsp;
        <b-button v-on:click.prevent="clear_all_recommended_drivers()" :disabled="updating">Clear All</b-button>
<!--        &nbsp;-->
<!--        <b-button v-on:click.prevent="send_all_to_tbn()" disabled>Send To TBN</b-button>-->
      </div>
    </div>
    <br clear="left"/>
    <br clear="left"/>

    <b-table v-if="this.items_full || this.loading" :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template slot="driver" slot-scope="row">
        <span :style="row.item.conflict_found ? 'color:darkorange' : ''">{{row.item.driver}}</span>
      </template>

      <template slot="charterID" slot-scope="row">
        <router-link style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + row.item.booking_hash }">{{ row.item.charterID }}</router-link>
      </template>

      <template slot="recommended_driver" slot-scope="row">
        <b-form-select v-model="row.item.recommended_driver" :style="row.item.rec_conflict_found ? 'color:red' : ''" :options="row.item.driver_options" @change="check_for_conflicts();update_assignment(row.item)"/>
      </template>

      <template slot="start_datetime" slot-scope="row">
        {{row.item.start_datetime | formatDateTimeSmall}}
      </template>

      <template slot="finish_datetime" slot-scope="row">
        {{row.item.finish_datetime | formatDateTimeSmall}}
      </template>

      <template slot="pickup_destination" slot-scope="row">
        <b>Organization:</b>{{row.item.org_name}}<br/>
        <span v-if="row.item.pickup != row.item.destination">
          <b>Pickup:</b> {{row.item.pickup.split(",")[0]}}<br/>
          <b>Dest:</b>{{row.item.destination.split(",")[0]}}
        </span>
        <span v-else>
          <b>Pickup/Dest:</b> {{row.item.pickup.split(",")[0]}}
        </span>
      </template>

      <template slot="attributes" slot-scope="row">
<!--        <b>Charter:</b> {{row.item.charter}}<br/>-->
        <span v-if="row.item.multiday" ><b>Multiday:</b> {{row.item.multiday}}<br/></span>
        <span v-if="row.item.late_night"><b>Late Night:</b> {{row.item.late_night}}<br/></span>
<!--        <span v-if="row.item.week_days"><b>Days:</b> {{row.item.week_days}}<br/></span>-->
      </template>

      <template slot="lock" slot-scope="row">
        <b-checkbox v-model="row.item.locked" size="lg" @change="save_assignment(row.item)"/>
      </template>

      <template slot="send" slot-scope="row">
        <b-btn size="sm" @click="send_to_tbn(row.item)" disabled>send</b-btn>
      </template>

      <template slot="details" slot-scope="row">
        <div v-if="row.item.driver_option_details.length > 0" style="align-content: center">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>&nbsp;
        </div>
      </template>

      <template slot="row-details" slot-scope="row">
        <b-card style="text-align: left; border: 2px solid grey">
          <h5>Available Driver Info</h5>
          <b-table sticky-header="70vh" bordered :items="row.item.driver_option_details" :fields="driver_options_fields" :current-page="currentPage" :per-page="perPage">
            
            <template slot="name" slot-scope="row">
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/driver_detail_tbn?id=' + row.item.id }">{{ row.item.name }}</router-link>
            </template>

            <template slot="attributes" slot-scope="row">
              <b>Type:</b> {{row.item.driver_info.driver_type}}<br/>
              <b>Seniority:</b> {{row.item.driver_info.seniority_level}}<br/>
              <b>Safety Rank:</b> {{row.item.driver_info.safety_score_rank}}<br/>
<!--              <b>Charter:</b> {{row.item.driver_info.charters}}<br/>-->
<!--              <span v-if="row.item.driver_info.multiday" ><b>Multiday:</b> {{row.item.driver_info.multiday}}<br/></span>-->
<!--              <b>Late Night:</b> {{row.item.driver_info.late_nights}}<br/>-->
<!--              <span v-if="row.item.driver_info.week_days"><b>Days:</b> {{row.item.driver_info.week_days}}<br/></span>-->
            </template>

            <template slot="last_finish_booking_hash" slot-scope="row">
              <router-link style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + row.item.last_finish_booking_hash }">{{ row.item.last_finish_booking_id }}</router-link>
            </template>

            <template slot="next_start_booking_hash" slot-scope="row">
              <router-link style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + row.item.next_start_booking_hash }">{{ row.item.next_start_booking_id }}</router-link>
            </template>
            
            <template slot="last_finish_time" slot-scope="row">
              {{row.item.last_finish_time | formatDateTimeSmall}}
            </template>

            <template slot="next_start_time" slot-scope="row">
              {{row.item.next_start_time | formatDateTimeSmall}}
            </template>

          </b-table>
        </b-card>
      </template>

    </b-table>
    <b-row v-if="this.items_full">
      <b-col>
        <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            align="center"
        >
        </b-pagination>
      </b-col>
    </b-row>

  </div>

</template>
<script>
import {tbn_get_smart_route_assignments, tbn_update_smart_route_assignment,tbn_send_smart_route_assignment_to_tbn, tbn_get_smart_route_assignment_vehicle_types} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'

export default {
  name: 'smart_route_assignments_tbn',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      items_full: null,
      summary: [],
      view_more_info: false,
      vehicle_type_options: [],
      selected_vehicle_types: [],
      loading: false,
      updating: false,
      details_fromDate: justDate(moment().add(7, 'days')),
      details_toDate: justDate(moment().add(14, 'days')),
      fields: [
        { key: 'details', label: '', sortable: false},
        { key: 'charterID', label: 'CharterID', sortable: true},
        { key: 'vehicle', label:'Vehicle', sortable: true},
        { key: 'vehicleType', label:'Vehicle Type', sortable: true, thStyle: { width: "180px" }},
        { key: 'attributes', label:'Attributes', sortable: true, thStyle: { width: "160px" }},
        { key: 'start_datetime', label:'Driver Start', sortable: true, thStyle: { width: "125px" }},
        { key: 'finish_datetime', label: 'Driver Finish', sortable: true, thStyle: { width: "125px" }},
        { key: 'routeDescription', label: 'Route', sortable: true},
        { key: 'pickup_destination', label: 'Pickup / Destination', sortable: true},
        { key: 'driver', sortable: true, label: 'Current TBN Driver'},
        { key: 'recommended_driver', sortable: true, label: 'Suggested Assignments'},
        { key: 'lock', sortable: true, label: 'Save'},
        // { key: 'send', sortable: true, label: 'Send To TBN'},
      ],
      driver_options_fields: [
        { key: 'name', label: 'Driver', sortable: true},
        { key: 'attributes', label:'Ranking', sortable: true, thStyle: { width: "150px" }},
        { key: 'last_finish_booking_hash', label:'Prev ID', sortable: true},
        { key: 'last_finish_time', label:'Prev Finish Time', sortable: true},
        { key: 'last_finish_location', label:'Prev Finish Location', sortable: true, thStyle: { width: "350px" }},
        { key: 'next_start_booking_hash', label:'Next ID', sortable: true},
        { key: 'next_start_time', label:'Next Start Time', sortable: true},
        { key: 'next_start_location', label:'Next Start Location', sortable: true, thStyle: { width: "350px" }},
        // { key: 'hos_last_8', label:'HOS Last 8 Days', sortable: true},
        // { key: 'host_next_8', label:'HOS Next 8 Days', sortable: true},
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
    this.load_vehicle_types()
  },
  methods: {
    async load_vehicle_types() {
      const {value: {data = []}} = await tbn_get_smart_route_assignment_vehicle_types(this.user.tenant)
      this.vehicle_type_options = data
    },
    async check_for_conflicts() {
      for (const item of this.items) {
        item.conflict_found = false
        item.rec_conflict_found = false
      }

      for (const item of this.items) {
        if (item.driver != null) {
          for (const other_item of this.items) {
            if (other_item.booking_hash !== item.booking_hash || other_item.vehicle !== item.vehicle) {
              if (other_item.recommended_driver === item.driver) {
                item.conflict_found = true
                other_item.rec_conflict_found = true
              }
            }
          }
        }
        if (item.recommended_driver != null) {
          for (const other_item of this.items) {
            if (other_item.booking_hash !== item.booking_hash || other_item.vehicle !== item.vehicle) {
              if (other_item.recommended_driver === item.recommended_driver) {
                other_item.rec_conflict_found = true
              }
            }
          }
        }
      }
      this.$forceUpdate();

    },
    async save_all_recommended_drivers() {
      if (confirm("Are you sure you want to save all driver assignments?")) {
        this.updating = true
        try {
          for (const item of this.items) {
            if (item.recommended_driver != null) {
              item.locked = true
              let json = {
                'booking_hash': item.booking_hash,
                'dispatch_id': item.dispatch_id,
                'recommended_driver': item.recommended_driver,
              }
              const {value: {data = []}} = await tbn_update_smart_route_assignment(this.user.tenant, json)
            }
          }
        } catch (e) {
          this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
        }
        this.updating = false
      }
    },
    async send_all_to_tbn() {
      if (confirm("Are you sure you want to send all driver assignments to TBN?")) {
        this.$emit('showAlert', 'sending assignments to TBN', 'info', 30000)
        this.updating = true
        try {
          for (const item of this.items) {
            if (item.recommended_driver != null) {
              let json = {
                'booking_hash': item.booking_hash,
                'dispatch_id': item.dispatch_id,
                'recommended_driver': item.recommended_driver
              }
              const {value: {data = []}} = await tbn_send_smart_route_assignment_to_tbn(this.user.tenant, json)
            }
          }
          this.$emit('showAlert', 'assignments sent to TBN successfully', 'success', 5000)

        } catch (e) {
          this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
        }
        this.updating = false
      }
    },
    async send_to_tbn(item) {
      if (confirm("Are you sure you want to send driver assignments to TBN?")) {
        this.$emit('showAlert', 'sending assignment to TBN', 'info', 30000)
        this.updating = true
        try {
          if (item.recommended_driver != null) {
            let json = {
              'booking_hash': item.booking_hash,
              'dispatch_id': item.dispatch_id,
              'recommended_driver': item.recommended_driver
            }
            const {value: {data = []}} = await tbn_send_smart_route_assignment_to_tbn(this.user.tenant, json)
          }
          this.$emit('showAlert', 'assignment sent to TBN successfully', 'success', 5000)

        } catch (e) {
          this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
        }
        this.updating = false
      }
    },
    async clear_all_recommended_drivers() {
      if (confirm("Are you sure you want to clear all driver assignments?")) {
        this.updating = true
        try {
          for (const item of this.items) {
            if (item.recommended_driver != null) {
              item.locked = false
              item.recommended_driver = null;

              let json = {
                'booking_hash': item.booking_hash,
                'dispatch_id': item.dispatch_id,
                'recommended_driver': null,
              }

              const {value: {data = []}} = await tbn_update_smart_route_assignment(this.user.tenant, json)
            }
          }

        } catch (e) {
          this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
        }
        // this.$forceUpdate();
        this.updating = false
      }
    },
    async save_assignment(item) {
      if (item.locked) {
        item.recommended_driver = null
        item.locked = false
      }

      if (item.recommended_driver == null) {
        item.locked = false
      }

      this.updating = true
      try {
        let json = {
          'booking_hash': item.booking_hash,
          'dispatch_id': item.dispatch_id,
          'recommended_driver': item.recommended_driver,
        }

        const {value: { data = [] } } = await tbn_update_smart_route_assignment(this.user.tenant, json)

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      // if (item.locked) {
      //   item.saved_driver = item.recommended_driver
      //   for (const other_item of this.items) {
      //     if (other_item.booking_hash != item.booking_hash)
      //       other_item.driver_options = other_item.driver_options.filter(driver_item => driver_item.value !== item.saved_driver)
      //   }
      // }
      // this.$forceUpdate();

      this.updating = false
    },
    async update_assignment(item) {
      if (!item.locked)
        return;

      this.updating = true
      try {
        let json = {
          'booking_hash': item.booking_hash,
          'dispatch_id': item.dispatch_id,
          'recommended_driver': item.recommended_driver,
        }

        const {value: { data = [] } } = await tbn_update_smart_route_assignment(this.user.tenant, json)

      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

      //item.saved_driver = item.recommended_driver
      // for (const other_item of this.items) {
      //   if (other_item.booking_hash != item.booking_hash)
      //     other_item.driver_options = other_item.driver_options.filter(driver_item => driver_item.value !== item.saved_driver)
      // }
      //
      // this.$forceUpdate();

      this.updating = false
    },
    async load_data(autoselect) {
      this.loading = true
      try {
        const {value: {data = []}} = await tbn_get_smart_route_assignments(this.user.tenant, this.selected_vehicle_types, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), autoselect)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.check_for_conflicts()
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      if (!this.items_full)
          return
      
      this.items = this.items_full
      if (this.booking_filter)
        this.items = this.items.filter(item => this.contains(item.charterID, this.booking_filter) || this.contains(item.driver, this.booking_filter) || this.contains(item.vehicle, this.booking_filter))
      if (this.selected_vehicle_types.length > 0)
        this.items = this.items.filter(item => item.vehicleMapType && this.selected_vehicle_types.includes(item.vehicleMapType))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    selected_vehicle_types() {
      this.filter_items()
    },
    booking_filter() {
      this.filter_items()
    },
  }
}
</script>

<style scoped>

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

.col2 { border-radius: 5px; margin:2px; padding: 0px 8px 0px 8px;}

</style>
